import React, {Fragment, useEffect, useState} from 'react';
import ListView from "../reusable/ListView/ListView";
import ListItem from "../reusable/ListView/ListItem";
import {useCSSVariables} from "../hooks/useCSSVariables";
import {IngredientDataHandler} from "../logic/db/IngredientDataHandler";
import {IngredientsModal} from "./IngredientsModal";
import {Svgs} from "../assets/svgs/Svgs";
import RoundButton from "../reusable/Actions/RoundButton";
import Center from "../reusable/Layouts/Center";
import {IngredientModel} from "../logic/models/IngredientModel";
import {useTranslation} from "react-i18next";
import {TranslationParser} from "../translations/TranslationParser";

function IngredientsListView() {
    const {t} = useTranslation("common")
    const cssVars = useCSSVariables()
    const [ingredients, setIngredients] = useState<IngredientModel[]>([])
    const [renderAddIngredientsModal, setRenderAddIngredientsModal] = useState(false)
    const [renderEditIngredientsModal, setRenderEditIngredientsModal] = useState(false)
    const [currentEditIngredient, setCurrentEditIngredient] = useState<IngredientModel | undefined>(undefined)

    useEffect(() => {
        IngredientDataHandler.getIngredients().then(result => {
            setIngredients((result as Ingredient[]).map(ingredient => new IngredientModel({ingredient})));
        }).catch(reason => {
            console.log(reason)
        })
        IngredientDataHandler.registerIngredientListener(
            (ingredients) => setIngredients(ingredients.map(ingredient => new IngredientModel({ingredient}))))
    }, [])

    const onCancelAddModal = () => setRenderAddIngredientsModal(false)
    const onCancelEditModal = () => setRenderEditIngredientsModal(false)
    console.log(currentEditIngredient)

    return (
        <div className="organisms-ingredientslistview">
            {ingredients.length > 0 ?
                <ListView>
                    {ingredients.map(ingredientModel => {
                        const tags = ingredientModel.retrieveListData().map(tag => TranslationParser.parseUnit(t, tag))
                        const editAction = () => {
                            setCurrentEditIngredient(ingredientModel)
                            setRenderEditIngredientsModal(true)
                            console.log("HEy", ingredientModel)
                        }
                        return <ListItem label={ingredientModel.ingredient.name}
                                      containerKey={ingredientModel.ingredient.name}
                                      key={ingredientModel.ingredient.name}
                                      tags={tags}
                                      actions={<IngredientItemActions ing={ingredientModel} editAction={editAction}/>}/>
                        }
                    )}
                </ListView> : null
            }
            <IngredientsModal mode={'edit'} ingredient={currentEditIngredient} render={renderEditIngredientsModal} onOuterClick={onCancelEditModal} onCancel={onCancelEditModal}/>
            <IngredientsModal mode={'add'} render={renderAddIngredientsModal} onOuterClick={onCancelAddModal} onCancel={onCancelAddModal}/>

            <Center>
                <RoundButton onMouseUp={() => setRenderAddIngredientsModal(true)} iconSvg={<Svgs.PlusSvg color={cssVars.PositiveColor}/>}/>
            </Center>
        </div>
    );
}

const IngredientItemActions = (props: {ing: IngredientModel, editAction: () => void}) => {
    const cssVars = useCSSVariables()
    const {ing}= props

    const onDelete = () => IngredientDataHandler.deleteIngredient(ing.ingredient)
    const onEdit = () => props.editAction()

    return (
        <Fragment>
            <RoundButton onMouseUp={onDelete} iconSvg={<Svgs.MinusSvg color={cssVars.NegativeColor}/>}/>
            <RoundButton onMouseUp={onEdit} iconSvg={<Svgs.EditSvg color={cssVars.DarkColor}/>}/>
        </Fragment>
    )
}

export default IngredientsListView;
